import { useState, useCallback, useRef, useEffect } from 'react';

export const useTransactionViewer = ({ fetchStatement, mappedTransactions }) => {
  const [currentTransaction, setCurrentTransaction] = useState(null);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleRowClick = useCallback((transaction) => {
    if (!transaction || transaction.matched_expense_name === '') return;
    if (isMountedRef.current) {
      setCurrentTransaction(transaction.raw_transaction ?? transaction);
    }
  }, []);

  const closeTransactionDialog = useCallback(() => {
    if (isMountedRef.current) {
      setCurrentTransaction(null);
      fetchStatement?.();
    }
  }, [fetchStatement]);

  const navigateTransaction = (direction) => {
    if (!currentTransaction || !Array.isArray(mappedTransactions) || mappedTransactions.length === 0) return;

    const currentIndex = mappedTransactions.findIndex((tx) => tx.transaction_id === currentTransaction.transaction_id);
    if (currentIndex === -1) return;

    let index = currentIndex;

    index = (index + direction + mappedTransactions.length) % mappedTransactions.length;
    const candidate = mappedTransactions[index];
    if (isMountedRef.current) {
      setCurrentTransaction(candidate.raw_transaction);
    }
  };

  return { currentTransaction, handleRowClick, closeTransactionDialog, navigateTransaction };
};
